var map = {
	"./WhatsApp Image 2025-01-01 at 13.10.00 (1).jpeg": 63337,
	"./WhatsApp Image 2025-01-01 at 13.10.00 (2).jpeg": 82878,
	"./WhatsApp Image 2025-01-01 at 13.10.00.jpeg": 37603,
	"./WhatsApp Image 2025-01-01 at 13.10.01 (1).jpeg": 46774,
	"./WhatsApp Image 2025-01-01 at 13.10.01 (2).jpeg": 6401,
	"./WhatsApp Image 2025-01-01 at 13.10.01 (3).jpeg": 23684,
	"./WhatsApp Image 2025-01-01 at 13.10.01.jpeg": 3516,
	"./WhatsApp Image 2025-01-01 at 13.10.02.jpeg": 3389,
	"./zWhatsApp Image 2025-01-01 at 13.09.57.jpeg": 6257,
	"./zWhatsApp Image 2025-01-01 at 13.09.58 (1).jpeg": 37286,
	"./zWhatsApp Image 2025-01-01 at 13.09.58 (2).jpeg": 80881,
	"./zWhatsApp Image 2025-01-01 at 13.09.58 (3).jpeg": 46452,
	"./zWhatsApp Image 2025-01-01 at 13.09.58 (4).jpeg": 30039,
	"./zWhatsApp Image 2025-01-01 at 13.09.58.jpeg": 25260,
	"./zWhatsApp Image 2025-01-01 at 13.09.59.jpeg": 71187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33912;